// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const CheckboxInput = ({ question, index, value, onMultiSelect, error, isSubmitted }) => {
//     if (!question.options || !Array.isArray(question.options)) {
//         return null;
//     }

//     const selectedValues = value || [];
//     const maxSelections = question.maxSelections;

//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <span className={styles.questionNumber}>Q{index + 1}</span>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                     {maxSelections && (
//                         <span className={styles.helperText}>
//                             (Select up to {maxSelections})
//                         </span>
//                     )}
//                 </label>
//             </div>

//             <div className={styles.optionsWrapper}>
//                 {question.options.map((option) => {
//                     const isChecked = selectedValues.includes(option);
//                     const isDisabled = isSubmitted || (!isChecked && maxSelections && selectedValues.length >= maxSelections);

//                     return (
//                         <label
//                             key={option}
//                             className={`${styles.checkboxOption} ${isChecked ? styles.checkboxOptionSelected : ''} ${isDisabled ? styles.disabled : ''}`}
//                             htmlFor={`${question.id}-${option}`}
//                         >
//                             <input
//                                 type="checkbox"
//                                 id={`${question.id}-${option}`}
//                                 checked={isChecked}
//                                 onChange={(e) => {
//                                     if (!isChecked && maxSelections && selectedValues.length >= maxSelections) {
//                                         alert(`You can select a maximum of ${maxSelections} options.`);
//                                         return;
//                                     }
//                                     onMultiSelect(question.id, option, e.target.checked);
//                                 }}
//                                 disabled={isDisabled}
//                                 className={styles.checkboxInput}
//                             />

//                             <span className={styles.checkboxBox}>
//                                 {isChecked && (
//                                     <svg className={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
//                                         <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                                     </svg>
//                                 )}
//                             </span>
//                             <span className={styles.optionText}>{option}</span>
//                         </label>
//                     );
//                 })}
//             </div>

//             {error && <ErrorMessage message={error} />}
//         </div>
//     );
// };

// export default CheckboxInput;

import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const CheckboxInput = ({ question, index, value, onMultiSelect, error, isSubmitted, disabled = false, onBlur }) => {
    if (!question.options || !Array.isArray(question.options)) {
        return null;
    }

    const selectedValues = value || [];
    const maxSelections = question.maxSelections;
    const isFormDisabled = disabled;

    const handleChange = (option, checked) => {
        if (!checked && maxSelections && selectedValues.length >= maxSelections) {
            alert(`You can select a maximum of ${maxSelections} options.`);
            return;
        }
        onMultiSelect(question.id, option, checked);
        // Note: Reason modal is now handled by handleImmediateFieldChange in DynamicForm
    };

    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                    {maxSelections && (
                        <span className={styles.helperText}>
                            (Select up to {maxSelections})
                        </span>
                    )}
                </label>
            </div>

            <div className={styles.optionsWrapper}>
                {question.options.map((option) => {
                    const isChecked = selectedValues.includes(option);
                    const isDisabled = isFormDisabled || (!isChecked && maxSelections && selectedValues.length >= maxSelections);

                    return (
                        <label
                            key={option}
                            className={`${styles.checkboxOption} ${isChecked ? styles.checkboxOptionSelected : ''} ${isDisabled ? styles.disabled : ''}`}
                            htmlFor={`${question.id}-${option}`}
                        >
                            <input
                                type="checkbox"
                                id={`${question.id}-${option}`}
                                checked={isChecked}
                                onChange={(e) => handleChange(option, e.target.checked)}
                                disabled={isDisabled}
                                className={styles.checkboxInput}
                            />

                            <span className={styles.checkboxBox}>
                                {isChecked && (
                                    <svg className={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                )}
                            </span>
                            <span className={styles.optionText}>{option}</span>
                        </label>
                    );
                })}
            </div>

            {error && <ErrorMessage message={error} />}
        </div>
    );
};

export default CheckboxInput;